import { TemplateContentBuildRevisionId } from '@deltasierra/ids';
import { PublishableService } from '@deltasierra/integrations-integration-types';
import { Brand, createBranded } from '@deltasierra/type-utilities';
import { BuilderTemplate, BuilderTemplateId } from '../builderTemplate';
import { Auditable, AuditableKeys, HasId, Omit, ParanoidAuditable } from '../common';
import { DeviceId } from '../devices';
import { SubChannel } from '../integration';
import { Location, LocationId } from '../location';
import { Upload, UploadId } from '../upload';
import { UserId } from '../user/User';
import { PublishedArtifactGroup } from './PublishedArtifactGroup';
import { PublishedArtifactMeta } from './PublishedArtifactMeta';

export type PublishedArtifactId = Brand<number, 'PublishedArtifactId'>;
export const PublishedArtifactId = createBranded<PublishedArtifactId>();

export interface PublishedArtifact extends Auditable, HasId<PublishedArtifactId>, ParanoidAuditable {
    artifact?: Upload;
    artifactId: UploadId | null;
    builderTemplate?: BuilderTemplate;
    builderTemplateId: BuilderTemplateId | null;
    channel: PublishableService;
    content: string | null;
    deviceId: DeviceId | null;
    downloadArtifactId: UploadId | null;
    draft: boolean;
    executionArn: string | null;
    externalArtifactId: string | null;
    externalTargetId: string | null;
    firstComment: string | null;
    firstCommentExecutionArn: string | null;
    instagramContainerId?: string | null;
    location?: Location;
    locationId: LocationId;
    meta: PublishedArtifactMeta | null;
    plannerId: number | null;
    publishedArtifactGroup?: PublishedArtifactGroup | null;
    publishedArtifactGroupId: number | null;
    scheduledTime: Date | null;
    subChannel: SubChannel | null;
    templateContentBuildRevisionId?: TemplateContentBuildRevisionId | null;
}

export type NewPublishedArtifact = Omit<
    PublishedArtifact,
    'artifact' | 'builderTemplate' | 'id' | 'location' | AuditableKeys
> & {
    createdById?: UserId | null;
    updatedById?: UserId | null;
};
